import PropTypes from 'prop-types';
import React from 'react';

import { translate as t } from '../../lib/I18n';

import Loading from '../general/Loading';

function LeftColumn ({ loading, children, className }) {
    if (loading) {
        return <Loading message={ t('booking.loading.results') } />;
    }

    return (
        <div className={ `left-col ${className}` }>
            { children }
        </div>
    );
}

LeftColumn.propTypes = {
    loading: PropTypes.bool,
    children: PropTypes.any,
    className: PropTypes.string
};

export default LeftColumn;



// WEBPACK FOOTER //
// ./src/components/layout/LeftColumn.js